var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMultipleChoice = function SvgMultipleChoice(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2563EB",
    d: "M8 8h6ZM8 12h6ZM2 4c0-.368.298-.666.667-.666h2c.368 0 .666.298.666.667v2a.667.667 0 0 1-.666.666h-2A.667.667 0 0 1 2 6.001V4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2563EB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 8h6m-6 4h6M8 4h6M2 10.738l1.265 1.264a8.097 8.097 0 0 1 2.462-2.667m-3.06-2.667h2a.667.667 0 0 0 .666-.666V4a.667.667 0 0 0-.666-.667h-2A.667.667 0 0 0 2 4.001v2c0 .368.298.666.667.666Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMultipleChoice);
export default ForwardRef;